export default "__VITE_ASSET__CXfBnGlR__"